import {SECCIONES} from "../Constantes";
import {useNavigate} from "react-router-dom";
import {Alert, Snackbar} from "@mui/material";
import {useState} from "react";

export const useIrRuta = () => {
    const navigate = useNavigate()
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');

    const abrirAviso = (men) =>{
        setMensaje('')
        setOpen(true)
        setMensaje(men)
    }

    const ir = (secc) => {

        switch (secc) {
            case SECCIONES[0]:
                navigate('/Home');
                break
            case SECCIONES[1]:
                abrirAviso('Por el momento no hay servicios disponibles')
                break
            case SECCIONES[2]:
                navigate('/Profesional')
                break
            case SECCIONES[3]:
                navigate('/Nosotros')
                break
        }
    }




    const Aviso = () => {

        return (
            <Snackbar
                open={open}
                onClose={() => setOpen(false)}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            >
                <Alert
                    severity={'info'}
                    variant="filled"
                    sx={{minWidth: 250,  borderRadius: 2}}

                >
                    {mensaje}
                </Alert>
            </Snackbar>
        )

    }

    return {
        ir,
        abrirAviso,
        Aviso,

    }


}